import { useMemo } from 'react';

import { generatePath } from 'react-router-dom';

import { STEPS } from 'components/modules/Insurance/Insurance.constants';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';

const { ROUTES } = Insurance;

export const usePreviousStepPathname = () => {
  const { params, route } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { id: worksheetId } = params ?? {};

  const previousRoute = useMemo(() => {
    for (let i = STEPS.length - 1; i >= 0; i--) {
      const { routes: currentRoutes } = STEPS[i];
      const { routes: previousRoutes } = STEPS[i - 1] ?? {};

      if (currentRoutes.has(route) && typeof previousRoutes !== 'undefined') {
        const routeList = Array.from(previousRoutes);

        return routeList[routeList.length - 1];
      }
    }
  }, [route]);
  const pathname = useMemo(() => {
    if (!previousRoute || !worksheetId) {
      return;
    }

    return generatePath(ROUTES[previousRoute].path, { id: worksheetId });
  }, [previousRoute, worksheetId]);

  return { pathname };
};
